module.exports = __webpack_public_path__ + "static/media/signatures.1ab2373f.png";